// Import axios and necessary types
import axios, { AxiosRequestConfig } from "axios";
import { ApiCallOptions } from "../types/ApiCallOption"; // Ensure this path is correct
import baseUrl from "../constants/baseurl"; // Ensure this path is correct

const apiCall = async ({
  service,
  endpoint,
  method = "GET",
  data = null,
  headers = null,
}: ApiCallOptions): Promise<any> => {
  // Construct full URL
  const url = `${baseUrl[service]}${endpoint}`;
  console.log("API Call URL:", url);

  try {
    // Axios request configuration
    const config: AxiosRequestConfig = {
      url,
      method, // Automatically typed by ApiCallOptions
      data,
      headers: headers || undefined, // Avoid null headers
    };

    // Execute Axios request
    const response = await axios(config);
    return response.data; // Return response data on success
  } catch (error: any) {
    console.error(`Error calling ${service} service:`, error);
    // Return error message or details
    return { error: error.response?.data?.message || error.message };
  }
};

export { apiCall };
